import React, { Component, useState, useEffect } from "react";
import AddView from "./AddView";
import Data from "../App";
import { Primitives } from "../primitives";
import { Map, List, is } from "immutable";
import { combineLatest } from "rxjs";
import { map, distinctUntilChanged } from "rxjs/operators";
import { getSuperType } from "./TypeHelper";

class UIView extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleSaveEdit = this.handleSaveEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleAttrChange = this.handleAttrChange.bind(this);
    this.handleAddAttrItem = this.handleAddAttrItem.bind(this);
    this.handleAttrDelete = this.handleAttrDelete.bind(this);
    this.handleAddAttrItem = this.handleAddAttrItem.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleAddCompTempSelected = this.handleAddCompTempSelected.bind(this);
  }

  componentDidMount() {
    console.log(
      "componentDidMount UiView " +
        this.props.compId +
        " in screen " +
        this.props.screenId
    );
    this.subscriptionTemp = combineLatest(
      Data.getInstance().getCompTemplates(),
      Data.getInstance().getSpecs()
    )
      .pipe(
        map(tempsSpecs => {
          let temps = tempsSpecs[0];
          let specs = tempsSpecs[1];
          let comp = specs.get(this.props.compId);
          let compType = comp.get("type");
          let compSuperType = getSuperType(compType, temps);
          let compTemplate = temps.get(compType);
          let screen = specs.get(this.props.screenId);
          let states = new Map();
          function addStates(stateId) {
            let state = specs.get(stateId);
            states = states.set(stateId, state);
            if (state.get("children"))
              state.get("children").forEach(child => addStates(child));
          }
          screen
            .get("vms")
            .map(vmId => specs.get(vmId))
            .forEach(vm => addStates(vm.get("rootState")));
          let uiEvents = screen.get("uiEvents").reduce((acc, evId) => {
            return acc.set(evId, specs.get(evId));
          }, new Map());
          console.log("mapped " + comp);
          return [comp, compSuperType, compTemplate, states, uiEvents];
        }),
        distinctUntilChanged((arr1, arr2) => {
          let same = true;
          for (let ind in arr1) {
            console.log("distinctUntilChanged checking " + ind);
            //console.log("distinctUntilChanged ind: " + ind + (ind === "3" || ind === "4"))
            if (ind === "3" || ind === "4") {
              if (!is(arr1[ind], arr2[ind])) {
                //console.log("distinctUntilChanged NOT SAME: " + arr1[ind] + " VVVVSSSSS " +  arr2[ind])
                same = false;
              }
            } else {
              if (arr1[ind] !== arr2[ind]) {
                //console.log("distinctUntilChanged NOT eq: " + arr1[ind] + " VVVVSSSSS " + arr2[ind])
                same = false;
              }
            }
          }
          console.log("distinctUntilChanged same? " + same);
          return same;
        })
      )
      .subscribe(data => {
        console.log("sub ");
        this.setState({
          comp: data[0],
          editedComp: data[0],
          compSuperType: data[1],
          template: data[2],
          states: data[3],
          uiEvents: data[4]
        });
      });

    this.subscriptionTempMap = Data.getInstance()
      .getCompTemplatesMapping()
      .subscribe(templatesMap => {
        //console.log("new templatesMapping " + JSON.stringify([...templatesMap]));
        this.setState({ templatesMap: templatesMap });
      });

    /*if (this.props.uiEvents) {
      this.subscriptionTypes = Data.getInstance()
        .getTypes()
        .pipe(
          filter(types => types.get(parseInt(this.props.uiEvents))),
          map(types => types.get(parseInt(this.props.uiEvents)).get("values"))
        )
        .subscribe(uiEvents => this.setState({ uiEvents: uiEvents }));
    }*/
  }

  componentWillUnmount() {
    this.subscriptionTemp.unsubscribe();
    this.subscriptionTypes.unsubscribe();
    this.subscriptionTempMap.unsubscribe();
  }

  handleCloseClick(event) {
    this.setState({ needTypeSelect: "" });
  }

  handleAddCompTempSelected(attr, typeTemplate) {
    this.setState({ needTypeSelect: "" });
    this.addTemplateAttr(attr, typeTemplate);
  }

  handleEditClick(event) {
    console.log("handleEditClick " + JSON.stringify(this.state.comp));
    this.setState({ editing: true, expanded: true });
  }

  handleExpandClick(event) {
    console.log("handleExpandClick");
    if (!this.state.editing) {
      this.setState((state, props) => ({
        expanded: !state.expanded
      }));
    }
  }

  handleSaveEdit() {
    console.log(
      "handleSaveEdit " +
        this.state.editedComp +
        " temp: " +
        this.state.template
    );
    if (this.state.template) {
      let saveObj = new Map();
      saveObj = saveObj.set("id", this.state.editedComp.get("id"));
      saveObj = saveObj.set("type", this.state.editedComp.get("type"));
      if (this.state.editedComp.get("parent"))
        saveObj = saveObj.set("parent", this.state.editedComp.get("parent"));
      else if (this.state.editedComp.get("target"))
        saveObj = saveObj.set("target", this.state.editedComp.get("target"));
      this.state.template.get("attributes").forEach(attr => {
        console.log(
          "handleSaveEdit attr " +
            attr +
            " Prim: " +
            Primitives.indexOf(attr.get("type")) +
            " editedComp " +
            this.state.editedComp.get(attr.get("attr"))
        );
        if (
          Primitives.indexOf(attr.get("type")) !== -1 &&
          this.state.editedComp.get(attr.get("attr"))
        ) {
          console.log(
            "saving attr " +
              attr.get("attr") +
              " => " +
              this.state.editedComp.get(attr.get("attr"))
          );
          saveObj = saveObj.set(
            attr.get("attr"),
            this.state.editedComp.get(attr.get("attr"))
          );
        }
      });
      Data.getInstance().changeSpec(saveObj);
      this.setState((state, props) => ({
        editing: false,
        expanded: false,
        editedComp: state.comp
      }));
    }
  }

  handleCancelEdit() {
    console.log("handleCancelEdit ");
    this.setState((state, props) => ({
      editing: false,
      expanded: false,
      editedComp: state.comp
    }));
  }

  handleDeleteClick() {
    console.log("handleDeleteClick " + this.state.comp);
    Data.getInstance().removeSpec(this.state.comp.get("id"));
  }

  handleAttrChange(attrName, value, isMultiAttr, index) {
    console.log(
      "handleAttrChange " +
        attrName +
        " -> " +
        value +
        " (current: " +
        this.state.editedComp.get(attrName)
    );

    if (isMultiAttr) {
      console.log(
        "handleAttrChange Multi pre " +
          this.state.editedComp.get(attrName) +
          "  index: " +
          index +
          " TO: " +
          this.state.editedComp.setIn([attrName, index], value)
      );
      this.setState((state, props) => ({
        editedComp: state.editedComp.setIn([attrName, index], value)
      }));
    } else {
      this.setState((state, props) => ({
        editedComp: state.editedComp.set(attrName, value)
      }));
    }
  }

  handleAttrDelete(attrName, isMultiAttr, index) {
    if (isMultiAttr) {
      this.setState((state, props) => ({
        editedComp: state.editedComp.deleteIn([attrName, index])
      }));
    } else {
      this.setState((state, props) => ({
        editedComp: state.editedComp.delete(attrName)
      }));
    }
  }

  handleAddAttrItem(attr) {
    console.log("handleAddAttrItem " + attr);
    let attrTypeName = attr.get("type");
    if (Primitives.indexOf(attrTypeName) >= 0) {
      this.addAttrValue(attr, "tbd");
    } else {
      let typeTemplates = this.state.templatesMap.get(attrTypeName);
      console.log("handleAddAttrItem t" + typeTemplates);
      if (typeTemplates) {
        if (typeTemplates.size > 1)
          this.setState({ needTypeSelect: [attr, typeTemplates] });
        else this.addTemplateAttr(attr, typeTemplates.get(0));
      }
    }
  }

  addAttrValue(attr, value) {
    console.log(
      "handleAddMultiAttrItem " +
        this.state.editedComp.set(attr.get("attr"), new List([""]))
    );
    if (!this.state.editedComp.get(attr.get("attr"))) {
      let toAdd;
      if (attr.get("quant") === "n?" || attr.get("quant") === "n!")
        toAdd = new List([value]);
      else toAdd = value;
      this.setState((state, props) => ({
        editedComp: state.editedComp.set(attr.get("attr"), toAdd)
      }));
    } else {
      console.log(
        "handleAddMultiAttrItem " +
          this.state.editedComp.get(attr.get("attr")) +
          " TO: " +
          this.state.editedComp.updateIn([attr.get("attr")], list =>
            list.push(value)
          )
      );
      this.setState((state, props) => ({
        editedComp: state.editedComp.updateIn([attr.get("attr")], list =>
          list.push(value)
        )
      }));
    }
  }

  addTemplateAttr(attr, typeTemplate) {
    let addedId = Data.getInstance().addComp(
      typeTemplate,
      this.state.comp.get("id")
    );
    //this.addAttrValue(attr, addedId); //in case of cancel or delete, later make sure that these added objects are deleted.
  }

  /*getStateOptions(rootState, selection) {
    console.log(
      "getStateOptions id: " +
      JSON.stringify(rootState.get("id")) +
      " SEL: " +
      JSON.stringify(selection) +
      " SEL?: " +
      (parseInt(selection) === rootState.get("id"))
    );
    let options = [];
    options.push(
      <option key={rootState.get("id")} value={rootState.get("id")}>
        {rootState.get("name")}
      </option>
    );
    if (rootState.get("childStates"))
      options.push(
        rootState
          .get("childStates")
          .map(state => this.getStateOptions(state, selection))
      );
    return options;
  }*/

  /*getStateSelections(rootState) {
    let options = [];
    options.push(<div>{rootState.get("name")}</div>);
    if (rootState.get("childStates"))
      options.push(
        rootState
          .get("childStates")
          .map(state => this.getStateSelections(state))
      );
    return options;
  }*/

  /*checkState(state, id) {
    console.log(
      "checkState " +
      id +
      " in " +
      state.get("id") +
      " => " +
      (state.get("id") === parseInt(id))
    );
    if (state.get("id") === parseInt(id)) return state;
    let found = null;
    if (state.get("childStates")) {
      state.get("childStates").forEach(childState => {
        let found2 = this.checkState(childState, id);
        if (found2) found = found2;
      });
    }
    return found;
  }

  findState(id) {
    if (!this.props.vms) return null;
    let found = null;
    this.props.vms.forEach(vm => {
      console.log("findState " + vm);
      if (vm.get("rootState")) {
        let found2 = this.checkState(vm.get("rootState"), id);
        if (found2) found = found2;
      }
    });
    console.log("found " + found);
    return found;
  }*/

  getName(attrName, attrValue, isMultiAttr, index) {
    let nameClass;
    switch (this.state.compSuperType) {
      case "view":
        nameClass = "ViewTitle";
        break;
      case "ui-binding":
        nameClass = "UiBinding";
        break;
      case "ui-action":
        nameClass = "UiAction";
        break;
      case "ui-single-reaction":
        nameClass = "UiSingleActionTitle";
        break;
      default:
        nameClass = "";
    }
    if (this.state.editing)
      return (
        <input
          form="uiForm"
          type="text"
          value={attrValue}
          onChange={e =>
            this.handleAttrChange(attrName, e.target.value, isMultiAttr, index)
          }
        />
      );
    else return <div className={nameClass}>{attrValue}</div>;
  }

  getStateSelect(attrName, selection, index, onChange) {
    return (
      <select
        form="uiForm"
        id={attrName + "-" + index}
        value={selection ? parseInt(selection) : ""}
        onChange={e => onChange(e.target.value)}
      >
        <option key="pick" disabled>
          Pick
        </option>
        {this.state.states.map(state => (
          <option key={state.get("id")} value={state.get("id")}>
            {state.get("name")}
          </option>
        ))}
      </select>
    );
  }

  getSelect(attrName, values, selection, index, onChange) {
    return (
      <fieldset
        form="uiForm"
        id={attrName + "-" + index}
        value={selection ? selection : ""}
        onChange={e => onChange(e.target.value)}
      >
        {values.map(val => (
          <span>
            <label for={val.get("value")}>{val.get("label")}</label>
            <input
              type="radio"
              id={val.get("value")}
              value={val.get("value")}
              name={attrName + "-" + index}
              checked={selection === val.get("value")}
            />
          </span>
        ))}
      </fieldset>
    );
  }

  getUiEvent(value) {
    let valueText = "";
    if (
      value &&
      this.state.uiEvents &&
      this.state.uiEvents.get(parseInt(value))
    ) {
      valueText = this.state.uiEvents.get(parseInt(value)).get("name");
    }
    return <div>{valueText}</div>;
  }

  getUiEventSelect(attrName, selection, onChange) {
    let options = [
      <option value="" disabled>
        Pick
      </option>
    ];
    if (this.state.uiEvents) {
      options = options.concat(
        this.state.uiEvents.valueSeq().map(ev => (
          <option
            value={ev.get("id")}
            selected={parseInt(selection) === ev.get("id") ? "selected" : ""}
          >
            {ev.get("name")}
          </option>
        ))
      );
    }
    return (
      <select
        form="uiForm"
        id={attrName}
        onChange={e => onChange(e.target.value)}
      >
        {options}
      </select>
    );
  }

  getViewForAttr(templateAttr, attrValue, isMultiAttr, index) {
    console.log("templateAttr " + templateAttr);
    let attrName = templateAttr.get("attr");
    let attrType = templateAttr.get("type");
    console.log(
      "getViewForAttr " +
        attrName +
        "attrType: " +
        attrType +
        " attrValue " +
        JSON.stringify(attrValue) +
        " states: " +
        this.state.states.get(parseInt(attrValue))
    );
    if (attrType === "name") {
      return this.getName(attrName, attrValue, isMultiAttr, index);
    } else if (attrType === "label")
      return this.state.expanded ? <div>{attrValue}</div> : "";
    else if (attrType === "state") {
      if (this.state.expanded) {
        return this.state.editing ? (
          this.getStateSelect(attrName, attrValue, index, newValue =>
            this.handleAttrChange(attrName, newValue, isMultiAttr, index)
          )
        ) : (
          <div className="UiStateRef">
            {this.state.states.get(parseInt(attrValue)).get("name")}{" "}
          </div>
        );
      } else return "";
    } else if (attrType === "select") {
      if (this.state.expanded) {
        let values = templateAttr.get("selectValues");
        function findSelectLabel() {
          let found = "NONE";
          values.forEach(val => {
            if (val.get("value") === attrValue) found = val.get("label");
          });
          return found;
        }
        return this.state.editing ? (
          this.getSelect(attrName, values, attrValue, index, newValue =>
            this.handleAttrChange(attrName, newValue, isMultiAttr, index)
          )
        ) : (
          <div>
            {templateAttr.get("name")}: {findSelectLabel()}
          </div>
        );
      } else return "";
    } else if (attrType === "ui-event") {
      console.log("attrType ui-event " + attrValue);
      if (this.state.expanded) {
        return this.state.editing
          ? this.getUiEventSelect(attrName, attrValue, newValue =>
              this.handleAttrChange(attrName, newValue, isMultiAttr, index)
            )
          : this.getUiEvent(attrValue);
      } else return "";
    } else if (attrType === "text") {
      if (this.state.expanded) {
        if (this.state.editing) {
          return (
            <textarea
              form="uiForm"
              id={attrName}
              value={attrValue}
              onChange={e =>
                this.handleAttrChange(
                  attrName,
                  e.target.value,
                  isMultiAttr,
                  index
                )
              }
            />
          );
        } else {
          return <div>{attrValue}</div>;
        }
      } else {
        return "";
      }
    } else if (attrType === "number")
      return this.state.expanded ? <div>{attrValue}</div> : "";
    else if (attrType === "boolean")
      return this.state.expanded ? <div>{attrValue}</div> : "";
    else return <UIView compId={attrValue} screenId={this.props.screenId} />;
    console.log("COULDNT HANDLE!");
  }

  render() {
    console.log("render UiView " + this.props.compId);
    var compToRender = [];
    if (!this.state.comp || !this.state.templatesMap) return "";
    console.log("render attr " + this.state.template.get("attributes"));
    this.state.template.get("attributes").forEach(attr => {
      let attrName = attr.get("attr");
      console.log(
        "render attr: " +
          this.state.comp.get("type") +
          " " +
          attrName +
          " obj: " +
          this.state.editedComp.get(attrName)
      );
      if (this.state.editedComp.get(attrName)) {
        //render existing
        if (attr.get("quant") === "n?" || attr.get("quant") === "n!") {
          compToRender.push(
            this.state.editedComp.get(attrName).map((value, index) => {
              let deletable =
                Primitives.indexOf(attr.get("type")) >= 0 &&
                this.state.editing &&
                (attr.get("quant") === "n?" || index > 0);
              let deleteIcon = deletable ? (
                <div
                  className="ViewDelete"
                  onClick={e => {
                    e.stopPropagation();
                    this.handleAttrDelete(attrName, true, index);
                  }}
                />
              ) : (
                ""
              );
              let key = this.state.comp.get("id") + attrName + index;
              let attrView = this.getViewForAttr(attr, value, true, index);
              if (deleteIcon)
                return (
                  <div key={key} className="AttrRow">
                    {attrView}
                    {deleteIcon}
                  </div>
                );
              else return <div key={key}>{attrView}</div>;
            })
          );
        } else if (attr.get("quant") === "1?" || attr.get("quant") === "1!") {
          let deletable =
            Primitives.indexOf(attr.get("type")) >= 0 &&
            this.state.editing &&
            attr.get("quant") === "1?";
          let deleteIcon = deletable ? (
            <span
              className="ViewDelete"
              onClick={e => {
                e.stopPropagation();
                this.handleAttrDelete(attrName, false, -1);
              }}
            />
          ) : (
            ""
          );
          compToRender.push(
            <div key={this.state.comp.get("id") + attrName}>
              {this.getViewForAttr(
                attr,
                this.state.editedComp.get(attrName),
                false,
                -1
              )}
              {deleteIcon}
            </div>
          );
        }
      }

      let adding = "";
      if (
        this.state.editing &&
        (!this.state.editedComp.get(attrName) ||
          (attr.get("quant") === "n?" || attr.get("quant") === "n!"))
      ) {
        let addSym;
        if (attr.get("quant") === "n?" || attr.get("quant") === "n!")
          addSym = "++";
        else addSym = "+";
        if (
          !this.state.editedComp.get(attrName) &&
          (attr.get("quant") === "n!" || attr.get("quant") === "1!")
        )
          addSym += "!";
        let key = attrName + "ADD";
        adding = (
          <div
            key={key}
            onClick={e => {
              e.stopPropagation();
              this.handleAddAttrItem(attr);
            }}
          >
            {addSym} {attr.get("name")}
          </div>
        );
      }
      compToRender.push(adding);
    });
    let titleRow;
    if (this.state.editing) {
      titleRow = (
        <div className="ViewTitleRow">
          <div
            className="AddUiViewConfirm"
            onClick={e => {
              e.stopPropagation();
              this.handleSaveEdit();
            }}
          />
          <div
            className="AddUiViewCancel"
            onClick={e => {
              e.stopPropagation();
              this.handleCancelEdit();
            }}
          />
          <div
            className="ViewDelete"
            onClick={e => {
              e.stopPropagation();
              this.handleDeleteClick();
            }}
          />
        </div>
      );
    } else {
      titleRow = (
        <div className="ViewTitleRow">
          <div
            className="ViewEdit"
            onClick={e => {
              e.stopPropagation();
              this.handleEditClick(e);
            }}
          />
        </div>
      );
    }
    let selectTempToAdd = !this.state.needTypeSelect ? (
      ""
    ) : (
      <div>
        {this.state.needTypeSelect[1].map(typeTemplate => (
          <button
            key={typeTemplate.get("type")}
            onClick={e =>
              this.handleAddCompTempSelected(
                this.state.needTypeSelect[0],
                typeTemplate
              )
            }
          >
            {typeTemplate.get("name")}
          </button>
        ))}
      </div>
    );

    let nameClass = "Comp";
    if (this.state.expanded) nameClass = "CompExpanded";
    else if (this.state.compSuperType === "view") nameClass = "View";
    return (
      <div
        className={nameClass}
        onClick={e => {
          e.stopPropagation();
          this.handleExpandClick(e);
        }}
      >
        {selectTempToAdd}
        {compToRender}
        <div className="ViewTitleRowContainer">{titleRow}</div>
      </div>
    );
  }
}

export default UIView;



// WEBPACK FOOTER //
// ./src/components/UIView.js